var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScientificName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 98,
    viewBox: "0 0 105 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.4074 2.51938L57.3627 24.514L64.3088 70.5801L82.3535 48.5855L75.4074 2.51938ZM25.0861 22.9562C16.9404 24.1844 8.42078 27.1823 3.05836 32.7022L12.3155 94.0958C12.4734 95.1428 13.6756 96.0323 14.7199 95.8748C15.1376 95.8118 15.3023 95.4872 15.72 95.4242C20.9489 91.8518 28.8167 88.7809 34.8737 87.8676C43.0194 86.6394 52.0442 86.9918 58.7958 90.6851C63.8984 86.2751 73.7222 82.0099 80.8235 80.9391C87.716 79.8998 95.0131 80.1273 101.335 82.3863C101.784 82.5327 101.98 82.4175 102.398 82.3545C103.442 82.197 104.329 80.9926 104.171 79.9457L94.958 18.8452C92.1675 17.3386 89.2629 16.4916 85.9721 15.9171L94.4968 72.4528C89.6808 71.6799 84.5733 71.8076 79.5606 72.5634C72.4593 73.6342 62.6355 77.8995 57.5329 82.3094L49.0082 25.7737C42.2566 22.0804 33.2317 21.7279 25.0861 22.9562Z",
    fill: "#D2EEE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientificName);
export default __webpack_public_path__ + "static/media/scientific_name.437d05e0.svg";
export { ForwardRef as ReactComponent };